(() => {
  const mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initCarousel = (root) => {
    if (!root || root.dataset.reviewCarouselReady === 'true') return;
    root.dataset.reviewCarouselReady = 'true';
    if (root.dataset.carouselActive !== 'true') return;

    const track = root.querySelector('[data-review-track]');
    const prev = root.querySelector('[data-review-prev]');
    const next = root.querySelector('[data-review-next]');
    const cards = Array.from(track?.querySelectorAll('[data-review-card]') || []);
    if (!track || cards.length <= 4) return;

    const originalCount = cards.length;
    cards.slice(0, Math.min(4, originalCount)).forEach((card) => {
      const clone = card.cloneNode(true);
      clone.removeAttribute('data-review-card');
      clone.removeAttribute('id');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      track.appendChild(clone);
    });

    let index = 0;
    let timer = null;
    let paused = false;

    const gap = () => parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
    const step = () => (cards[0]?.getBoundingClientRect().width || 0) + gap();

    const move = (animate = true) => {
      track.style.transition = animate && !mqReduced.matches ? 'transform .55s cubic-bezier(.22,.61,.36,1)' : 'none';
      track.style.transform = `translate3d(${-index * step()}px,0,0)`;
    };

    const goNext = () => {
      index += 1;
      move(true);
    };

    const goPrev = () => {
      if (index === 0) {
        index = originalCount;
        move(false);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          index = originalCount - 1;
          move(true);
        }));
      } else {
        index -= 1;
        move(true);
      }
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!paused && !mqReduced.matches) timer = window.setInterval(goNext, 6000);
    };

    track.addEventListener('transitionend', () => {
      if (index >= originalCount) {
        index = 0;
        move(false);
      }
    });

    prev?.addEventListener('click', () => { goPrev(); start(); });
    next?.addEventListener('click', () => { goNext(); start(); });

    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin', () => { paused = true; stop(); });
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) {
        paused = false;
        start();
      }
    });

    window.addEventListener('resize', () => move(false), { passive: true });
    mqReduced.addEventListener?.('change', start);
    move(false);
    start();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-review-carousel]').forEach(initCarousel);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
